import { useQueryClient } from '@tanstack/react-query';

import { summaryQueries } from './queries';

export const useInvalidateSummary = (pharmacyId?: string) => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({
      queryKey: summaryQueries.all(pharmacyId),
    });
  };
};
